module.exports = __webpack_public_path__ + "img/logo-bg-white.253d82f3.svg";